import { render, staticRenderFns } from "./BaseWeekScheduledItemCard.vue?vue&type=template&id=6a98f10c&scoped=true&"
import script from "./BaseWeekScheduledItemCard.vue?vue&type=script&lang=js&"
export * from "./BaseWeekScheduledItemCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseWeekScheduledItemCard.vue?vue&type=style&index=0&id=6a98f10c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a98f10c",
  null
  
)

export default component.exports